module.exports = __webpack_public_path__ + "img/template3.c45b1bfe.svg";